import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ClosePopoutTimerService } from '../../services/close-popout-timer.service';
import {
  WorkPanelBarItem,
  WorkPanelBarItemType,
} from 'xsmodules/ticket/components/work-panel/models/work-panel-bar-items';

export enum DisplayMode {
  ExpandCollapse = 1,
  AlwaysOpen = 2,
}

@Component({
  selector: 'app-toolbar-popover',
  templateUrl: './toolbar-popover.component.html',
  styleUrls: ['./toolbar-popover.component.scss'],
})
export class ToolbarPopoverComponent implements OnInit, OnDestroy {
  @Input() displayMode: DisplayMode = DisplayMode.ExpandCollapse;
  @Input() collapsedButton: WorkPanelBarItem;
  @Input() expandedButtons: WorkPanelBarItem[];

  public WorkPanelBarItemType = WorkPanelBarItemType;
  private overItem: WorkPanelBarItem;
  private isPopOverVisible = false;
  private delayBeforeOpeningPopover = 50;
  private popOverSubscription: Subscription;
  uniqueId: number;
  private closePopoutTimerService: ClosePopoutTimerService;

  ngOnInit() {
    this.uniqueId = new Date().getTime();
    switch (this.displayMode) {
      case DisplayMode.AlwaysOpen: {
        this.isPopOverVisible = true;
        break;
      }
      default:
        break;
    }

    this.closePopoutTimerService = new ClosePopoutTimerService('.popover-container-box:hover', (): void => {
      this.onMouseLeave();
    });
  }

  ngOnDestroy() {
    if (this.popOverSubscription) {
      this.popOverSubscription.unsubscribe();
    }

    this.closePopoutTimerService.clearTimer();
  }

  public get popOverOpen() {
    return this.isPopOverVisible;
  }

  public get expandedButtonsVisibleCount(): number {
    return this.expandedButtons.filter(i => i.isVisible && i.isVisible()).length;
  }

  public get expandedButtonsShadowClass(): string {
    // We do not need shadow when there is only 1 visible button in the popover.
    return this.expandedButtonsVisibleCount > 1 ? 'popover-container-box-shadow' : '';
  }

  public get collapsedButtonClass() {
    return this.collapsedButton.cssClass ? this.collapsedButton.cssClass() : '';
  }

  public get isVisible(): boolean {
    return (
      this.collapsedButton && this.expandedButtons && this.collapsedButton.isVisible && this.collapsedButton.isVisible()
    );
  }

  public get overTooltip(): string {
    return this.overItem ? this.overItem.tooltip() : '';
  }

  public onMouseEnter(item: WorkPanelBarItem) {
    // We use one div for a tooltip and it depends on the over button to show different messages.
    if (item) {
      this.overItem = item;
    }

    // We need this delay to avoid a situation when popover quickly opens and quickly closes (flashes).
    this.popOverSubscription = new Observable(o => {
      setTimeout(() => {
        o.next();
      }, this.delayBeforeOpeningPopover);
    }).subscribe(() => {
      // We need this check to avoid an open popover when we not above button.
      // Sometimes popover does not close, and the delay and this check exclude this situation.
      // We need uniqueId to identify multiple instanses of toolbar-popover component on the page.
      if ($(`.collapsedButton-${this.uniqueId}:hover`).length === 0) {
        return;
      }

      if (
        (this.collapsedButton && this.collapsedButton.isDisabled && !this.collapsedButton.isDisabled()) ||
        this.displayMode === DisplayMode.AlwaysOpen
      ) {
        this.isPopOverVisible = true;
      }
    });

    this.closePopoutTimerService.startTimer();
  }

  public onClick = (item: WorkPanelBarItem): void => {
    if (!item) {
      return;
    }

    if (item.isDisabled()) {
      return;
    }

    if (item.type !== this.WorkPanelBarItemType.Button) {
      return;
    }

    item.onClick(item);
  };

  private onMouseLeave = () => {
    if (this.displayMode === DisplayMode.AlwaysOpen) {
      return;
    }

    if (this.popOverSubscription) {
      this.popOverSubscription.unsubscribe();
    }

    this.isPopOverVisible = false;
  };
}
